export default __webpack_public_path__ + "images/a56e63a727ed435b7b0d09f940065942-level2.png";